import React from 'react'
import PrevNext from './PrevNext.jsx'
import classnames from 'classnames'
import { ViewerContext } from '../context/ViewerContext'
import SeadragonViewer from './OpenSeaDragon.jsx'
import Handle from './Handle.jsx'
import Paginator from './Paginator.jsx'
import * as R from 'ramda'
import { notebookViewerProps } from '../types'
class NotebookViewer extends React.Component {
     static propTypes = notebookViewerProps
     constructor(props) {
          super(props)
     }
     renderInfoSvg() {
          return (
               <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
               >
                    <g fill="currentColor" fillRule="evenodd">
                         <path
                              stroke="currentColor"
                              strokeWidth="2"
                              d="M3.05 3.05a7 7 0 1 0 9.901 9.9 7 7 0 0 0-9.9-9.9z"
                         />
                         <path
                              fill="#262626"
                              d="M8.32 3.356c.676 0 1.217.557 1.217 1.233 0 .675-.558 1.233-1.216 1.233a1.243 1.243 0 0 1-1.233-1.25c0-.675.557-1.216 1.233-1.216zM10.06 11.614a.808.808 0 0 1-.169.287c-.439.456-.98.726-1.62.726-.305 0-.592 0-.896-.05-.49-.068-1.114-.676-1.03-1.318l.203-1.317.405-2.297c0-.05.017-.1.017-.152 0-.32-.101-.439-.422-.472-.135-.017-.27-.034-.406-.068-.151-.05-.236-.186-.219-.304.017-.135.101-.22.27-.253.085-.017.186-.017.287-.017h2.331c.287 0 .455.135.455.422 0 .236-.033.473-.084.71-.152.877-.32 1.739-.473 2.617-.05.287-.118.574-.152.86-.017.136 0 .288.034.423.05.186.186.287.372.27a1.56 1.56 0 0 0 .455-.135c.119-.05.22-.135.338-.169.203-.067.355.051.304.237z"
                         />
                    </g>
               </svg>
          )
     }
     renderHandle(viewerType) {
          if (viewerType === 'viewer') {
               return (
                    <Handle
                         toggledSetting={this.context.state.toggledSetting}
                         updateToggle={this.context.updateToggle}
                    />
               )
          } else {
               return
          }
     }
     renderTitle(viewerType) {
          if (viewerType === 'viewer') {
               return (
                    <div className="viewer__title">
                         Kramář Notebook, 1913 (Folio {this.props.folioNum})
                    </div>
               )
          } else {
               return
          }
     }
     getAllColorNotes(obj) {
          return R.map(x => x.colorNotes, obj)
     }
     render() {
          const renderClasses = classnames('viewer-container', {
               'viewer-container--both':
                    this.context.state.toggledSetting === 'both',
               'viewer-container--closed':
                    this.context.state.toggledSetting === 'none' ||
                    this.props.viewerType === 'catalog',
          })
          const left = this.props.left
          const right = this.props.right
          const totalPages =
               this.props.viewerType === 'catalog'
                    ? this.context.catalogTotalPages
                    : this.context.viewerTotalPages
          return (
               <div className={renderClasses}>
                    <div className="viewer">
                         {this.renderHandle(this.props.viewerType)}
                         <SeadragonViewer
                              currentView={this.props.currentView}
                              leftSections={left ? left.sections : null}
                              rightSections={right ? right.sections : null}
                              leftColorNotes={
                                   left
                                        ? this.getAllColorNotes(left.sections)
                                        : null
                              }
                              rightColorNotes={
                                   right
                                        ? this.getAllColorNotes(right.sections)
                                        : null
                              }
                              tilePrefix={this.props.tilePrefix}
                              folioNum={this.props.folioNum}
                              highlightedSection={
                                   this.context.state.highlightedSection
                              }
                              highlightSection={this.context.highlightSection}
                              setZoomLevelState={this.context.setZoomLevelState}
                         />
                         <PrevNext
                              currentView={this.props.currentView}
                              leftTitle={left ? left.title : null}
                              paginatorOpen={this.context.state.paginatorOpen}
                              rightTitle={right ? right.title : null}
                              paginatorHeight={
                                   this.context.state.paginatorHeight
                              }
                              setPaginatorState={this.context.setPaginatorState}
                              viewerType={this.props.viewerType}
                         />
                    </div>
                    <Paginator
                         viewerType={this.props.viewerType}
                         paginatorOpen={this.context.state.paginatorOpen}
                         paginatorHeight={this.context.state.paginatorHeight}
                         setPaginatorState={this.context.setPaginatorState}
                         tilePrefix={this.props.tilePrefix}
                         totalPages={totalPages}
                    />
               </div>
          )
     }
}
NotebookViewer.contextType = ViewerContext

export default NotebookViewer
